import { CaretDownOutlined } from '@vindr/icons';
import { Input, Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetInstitutions } from '@vindr/services/actions/institution.action';
import { MODALITIES } from '@vindr/services/constants/study.constant';
import { FILTER_TYPE } from './constants';

const { Option } = Select;

const useSearchOptions = (params, handleOnChangeFilter) => {
  const { t } = useTranslation('Vindoc');
  const institutions = useGetInstitutions({ offset: 0, limit: 100 })?.data?.data || [];

  const InputItem = (params, key, placeholder = t('Keyword')) => {
    return (
      <Input
        size="small"
        className="w-40"
        value={params[key]}
        placeholder={t(placeholder)}
        onChange={(event) => handleOnChangeFilter(params, key, event?.target?.value)}
        onPressEnter={(event) =>
          handleOnChangeFilter(params, key, (event?.target as HTMLInputElement)?.value, true)
        }
        allowClear
      />
    );
  };

  return useMemo(
    () => [
      {
        text: t('Institution'),
        key: FILTER_TYPE.INSTITUTION,
        component: (
          <Select
            size="small"
            mode="multiple"
            allowClear
            disabled
            maxTagCount="responsive"
            suffixIcon={<CaretDownOutlined />}
            placeholder={t('Select Institution')}
            className="select-dropdown-light w-40"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.INSTITUTION, value, true);
            }}
            value={params[FILTER_TYPE.INSTITUTION] || []}
            filterOption={(input, option) =>
              String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              option.key.toLowerCase().includes(input.toLowerCase())
            }
          >
            {institutions
              ? institutions.map((it, idx) => (
                  <Select.Option key={idx} value={it?.id}>
                    {it?.name}
                  </Select.Option>
                ))
              : null}
          </Select>
        ),
      },
      {
        text: t('Procedure Code'),
        key: FILTER_TYPE.PROCEDURE_CODE,
        component: InputItem(params, FILTER_TYPE.PROCEDURE_CODE, t('Enter Procedure Code')),
      },
      {
        text: t('Procedure Name'),
        key: FILTER_TYPE.PROCEDURE_NAME,
        component: InputItem(params, FILTER_TYPE.PROCEDURE_NAME, t('Enter Procedure Name')),
      },
      {
        text: t('Modality'),
        key: FILTER_TYPE.MODALITY,
        component: (
          <Select
            size="small"
            showSearch
            placeholder={t('Select Modality')}
            className="select-dropdown-light w-40"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.MODALITY, value, true);
            }}
            allowClear
            value={params[FILTER_TYPE.MODALITY] || null}
          >
            {MODALITIES.map((it) => (
              <Option key={it} value={it}>
                {it}
              </Option>
            ))}
          </Select>
        ),
      },
    ],
    [t, params, institutions, handleOnChangeFilter]
  );
};

export default useSearchOptions;
